<template>
  <div class="recognition-filters">
    <slot name="prepend" />
    <b-form-select
      v-if="!programId"
      :value="selectedProgram"
      :options="programOptions"
      class="recognition-filters__filter"
      @input="$emit('update:selected-program', $event)"
    />
    <b-form-select
      :value="selectedDateRange"
      :options="dateRangeOptions"
      class="recognition-filters__filter"
      @input="$emit('update:selected-date-range', $event)"
    />
    <b-button v-if="hasActiveFilters" variant="link" class="recognition-filters__reset" @click="$emit('reset')">
      <font-awesome-icon :icon="['fal', 'times']" class="mr-1" />
      Reset filters
    </b-button>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  programs: {
    type: Array,
    default: () => [],
  },
  programId: {
    type: String,
    default: null,
  },
  selectedProgram: {
    type: String,
    default: null,
  },
  selectedDateRange: {
    type: String,
    default: null,
  },
  dateRangeOptions: {
    type: Array,
    required: true,
  },
  hasActiveFilters: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['update:selected-program', 'update:selected-date-range', 'reset']);

const programOptions = computed(() => {
  const options = [{ value: null, text: 'All Awards' }];
  for (const program of props.programs) {
    options.push({
      value: program.recognition_award_program_id,
      text: program.program_name,
    });
  }
  return options;
});
</script>

<style scoped lang="scss">
.recognition-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1rem 1rem;
  margin-bottom: 1rem;
  background: var(--palette-color-default-lighten-95);
  border-radius: 0.5rem;

  :deep(.recognition-filters__filter) {
    width: auto;
    min-width: 150px;
    border-color: var(--palette-color-default-lighten-80);
    padding: 0.5rem 1rem;

    &:focus {
      border-color: var(--palette-color-primary);
      box-shadow: none;
    }
  }

  &__reset {
    color: var(--palette-color-default);
    text-decoration: none;
    padding: 0.5rem 1rem;

    &:hover {
      text-decoration: none;
      color: var(--palette-color-default-lighten-20);
    }
  }
}
</style>
